export default __webpack_public_path__ + "static/media/browser-firefox.bd0ec2c3.png";